import {
  EStatsService,
  EStatsInner,
  EStatsType,
} from '@enums/dashboard';

export const SERVICE_STATS_TYPES_ORDER: EStatsService[] = [
  EStatsService.SrsRecoveries,
  EStatsService.SrsAuction,
  EStatsService.VRM,
  EStatsService.ExpressRecoveriesVehicles,
  EStatsService.ExpressRecoveriesProducts,
  EStatsService.AuctionPosted,
  EStatsService.AuctionSold,
  EStatsService.Reindeer,
];

export const INNER_STATS_TYPES_ORDER: EStatsInner[] = [
  EStatsInner.VinDecodeSuccess,
  EStatsInner.VinDecodeFailed,
  EStatsInner.AdsTotal,
  EStatsInner.AdsRunning,
  EStatsInner.InvoiceAmount,
  EStatsInner.AuctionBids,
];

export const STATS_TABLE_TITLE: Record<EStatsType, string> = {
  [EStatsType.Services]     : 'Services Statistics',
  [EStatsType.InnerMonthly] : 'Inner Monthly Statistics',
  [EStatsType.InnerTotal]   : 'Inner Total Statistics',
};
